// @owners { team: patient-fulfillment }
import { type BACKGROUND_COLORS_VALUES, COLORS } from '@alto/design-library-tokens';
import { PresentationListItem } from '@alto/design-system';
import React from 'react';
import { formatMedications } from '~shared/helpers/medication';

type Props = {
  readonly medicationNames: string[];
  readonly isLastRefill?: boolean;
  readonly backgroundColor?: BACKGROUND_COLORS_VALUES;
  readonly showAllMeds?: boolean;
};

export const DeliveryCardMedRow = ({ medicationNames, isLastRefill, backgroundColor, showAllMeds }: Props) => {
  if (medicationNames.length === 0) {
    return null;
  }

  let text = showAllMeds ? medicationNames.join('\n') : formatMedications(medicationNames).allMedications;
  if (isLastRefill) {
    text += "\nLast refill! Request more so you don't run out.";
  }

  return (
    <PresentationListItem
      data-testid="delivery-card-med-row"
      iconName={isLastRefill ? 'alert' : 'pillbottle'}
      text={text}
      backgroundColor={isLastRefill ? COLORS.BACKGROUND_COLORS.DANGER_LIGHTEST : backgroundColor}
    />
  );
};
